export enum  IncomeSource{

    BUSINESS = 'BUSINESS' ,

    INHERITANCE_DONATION = 'INHERITANCE_DONATION' ,

    PENSION = 'PENSION',

    PROPERTY_RENT = 'PROPERTY_RENT',

    OTHERS = 'OTHERS'
}